import '../App.css';
import React from 'react';
import { write, useSnap } from '../store'
import { CountdownCircleTimer } from 'react-countdown-circle-timer'
import toast from 'react-hot-toast';
import { pack } from 'msgpackr';
// import { WsContext } from '../App'

function CD() {
    const read = useSnap()
    // const ws = React.useContext(WsContext);
    const ws = read.ws
    const activeQuestion = read.questions[read.currentQuestion - 1]
    const questionType = activeQuestion?.questionType

    const timerByType = {
        reading: 20,
        listening: 60,
        writing: 600,
        speaking: 60,
    }

    const timer = timerByType[questionType] || 60;

    const determineData = React.useCallback((type) => {
        switch (type) {
            case 'speaking':
                return `${read.id}-speaking-${read.questions[read.currentQuestion - 1].qID}.mp4`
            case 'writing':
                return read.writingAllWords
            default:
                return 'out'
        }
    }, [read.currentQuestion, read.id, read.questions, read.writingAllWords])

    return (
        <CountdownCircleTimer
            key={`${read.currentQuestion}-${questionType}-${timer}`}
            onComplete={() => {
                if (read.totalQuestions >= read.currentQuestion && !read.loading) {
                    write.currentQuestion = read.currentQuestion + 1
                    ws.send(pack({
                        type: 'ONE_ANSWER',
                        data: determineData(questionType),
                        index: read.currentQuestion - 1,
                        id: read.id
                    }))
                    if (questionType === 'speaking') {
                        read.recorder.stop()
                        ws.send(pack({ type: 'REC_FINISHED', format: activeQuestion?.qID }))
                    }
                    return { shouldRepeat: true, delay: .5 }
                } if (read.loading) {
                    toast.error('You are disconnected from the Internet ❌', { duration: Infinity })
                } else {
                    console.log('end of questions')
                }
            }}
            size={read.OS === 'PC' ? 64 : 52}
            isPlaying={(read.instruction[questionType] && !read.stopTimer) ? true : false}
            duration={timer}
            colors={['#004777', '#F7B801', '#FF8C00', '#A30000']}
            colorsTime={questionType === 'reading' ? [20, 15, 10, 0] : [45, 35, 20, 0]}
        >
            {({ remainingTime }) => remainingTime}
        </CountdownCircleTimer>

    );
}

export default CD;
